import moment from "moment";

export const itemColor = (item) => {
  if (!item.startDate || !item.endDate) return "item-red";
  if (moment(item.startDate, "YYYY-MM-DD") > moment()) return "item-blue";
  if (moment(item.endDate, "YYYY-MM-DD") < moment()) return "item-orange";
}
